import React from "react";
import LegalLayout from "./LegalLayout";

const P = ({ children }) => <p>{children}</p>;
const UL = ({ children }) => (
  <ul className="list-disc list-outside pl-6 space-y-2 marker:text-[#B08D57]">
    {children}
  </ul>
);

export default function Disclosures() {
  return (
    <LegalLayout
      eyebrow="Regulatory"
      title="Regulatory Disclosures"
      updated="February 2026"
      sections={[
        {
          id: "regulators",
          title: "1. Who we are regulated by",
          body: (
            <UL>
              <li>
                <strong>Financial Services Regulatory Authority of
                Ontario (FSRA)</strong>: regulates our life, accident &amp;
                sickness insurance activity in Ontario. Our licensed
                representatives are individually authorized under the{" "}
                <em>Insurance Act</em> (Ontario).
              </li>
              <li>
                <strong>Canadian Investment Regulatory Organization
                (CIRO)</strong>: oversees dealer members through which our
                clients hold mutual-fund and segregated-fund investments.
              </li>
              <li>
                <strong>Ontario Securities Commission (OSC)</strong>: the
                statutory regulator for securities in Ontario.
              </li>
              <li>
                <strong>Canadian Investor Protection Fund (CIPF)</strong>:
                provides limited coverage of client assets in the event of a
                CIRO dealer-member insolvency, subject to CIPF coverage
                limits and rules.
              </li>
              <li>
                Our advisors are members of <strong>Advocis</strong>, the
                Financial Advisors Association of Canada.
              </li>
            </UL>
          ),
        },
        {
          id: "compensation",
          title: "2. How we are compensated",
          body: (
            <>
              <P>
                We are transparent about compensation. Before any product is
                sold, you will receive written disclosure of:
              </P>
              <UL>
                <li>
                  The commission or fee we receive, and from whom.
                </li>
                <li>
                  Any override, bonus, conference credit or non-monetary
                  benefit tied to the product recommendation.
                </li>
                <li>
                  Whether we are paid a level, up-front, or trailing
                  commission, and the schedule.
                </li>
              </UL>
              <P>
                You are entitled to ask, at any time, for a written summary
                of all compensation associated with a recommendation. We will
                provide it promptly.
              </P>
            </>
          ),
        },
        {
          id: "conflicts",
          title: "3. Conflicts of interest",
          body: (
            <>
              <P>
                As an independent practice we access products from many
                carriers. Conflicts can still arise, for example, one carrier
                may pay a higher commission than another for a comparable
                product. We identify and address material conflicts as
                follows:
              </P>
              <UL>
                <li>
                  We document the comparison and demonstrate why the
                  recommended product is in the client's best interest, on
                  its merits.
                </li>
                <li>
                  We disclose any conflict, in writing, before you sign an
                  application.
                </li>
                <li>
                  Where a conflict cannot be resolved in the client's favour,
                  we decline the transaction.
                </li>
              </UL>
            </>
          ),
        },
        {
          id: "carriers",
          title: "4. Carriers we represent",
          body: (
            <>
              <P>
                Prospera arranges products through a broad panel of licensed
                Canadian insurance carriers and CIRO dealer members. A current
                list is available on request. Representative names include
                (without limitation): Beneva, Canada Life, Manulife, Empire
                Life, Equitable Life, iA Financial Group, Foresters, Desjardins
                Insurance, and BMO.
              </P>
              <P>
                Representation of a carrier does not imply endorsement, and
                availability of a product is subject to the carrier's own
                underwriting and issuance rules.
              </P>
            </>
          ),
        },
        {
          id: "kyc",
          title: "5. Know-Your-Client & suitability",
          body: (
            <P>
              Regulation requires us to know you before we can advise you.
              That means we ask about your financial situation, investment
              knowledge, time horizon, risk tolerance and objectives. Any
              recommendation we make must be suitable given that picture. If
              your circumstances change materially, please tell us so we can
              re-assess suitability.
            </P>
          ),
        },
        {
          id: "advice-vs-info",
          title: "6. Advice vs. general information",
          body: (
            <P>
              Content on this Site is educational only. Personal advice, the
              kind you can rely on, is delivered inside a signed advisory
              engagement, after a full KYC. If in doubt, book a consultation
              before acting.
            </P>
          ),
        },
        {
          id: "risks",
          title: "7. Risk warnings",
          body: (
            <UL>
              <li>
                <strong>Insurance</strong>: policies are contracts with the
                carrier. Coverage terms, exclusions and premium schedules are
                defined by the contract. Illustrations are not contracts.
              </li>
              <li>
                <strong>Investments</strong>: the value of an investment can
                go down as well as up. Segregated fund guarantees are
                provided by the insurer and are subject to conditions.
              </li>
              <li>
                <strong>Tax</strong>: tax law changes. Any tax outcome
                referenced on this Site reflects our understanding at the
                time of publication and is not a substitute for advice from a
                licensed tax professional.
              </li>
            </UL>
          ),
        },
      ]}
    />
  );
}
